/**
 * "Your sale is saved" on the sign-in and PIN screens.
 *
 * A reload at the counter has to ask for the PIN or password — the till is at a public counter,
 * and a reload must not hand it to whoever is standing there. What it must not do is look as if
 * the sale was lost: a tester reloaded mid-sale, landed on sign-in, and failed the case. The cart
 * is on the device and comes back the moment the same person is in; this says so up front.
 */

import { savedItemCount } from '../model/cartStorage.js';

export function SavedSaleNotice({
  userId,
  fullName,
}: {
  userId: string | undefined;
  fullName: string | undefined;
}) {
  const count = userId === undefined ? 0 : savedItemCount(userId);
  if (count === 0) return null;

  return (
    <p
      role="status"
      className="rounded-card bg-surface-sunken px-4 py-3 text-sm text-content-primary"
    >
      <span className="font-semibold">
        {fullName === undefined ? 'The' : `${fullName}'s`} sale is saved — {count}{' '}
        {count === 1 ? 'item' : 'items'}.
      </span>{' '}
      It comes back as soon as {fullName === undefined ? 'you are' : 'they are'} in.
    </p>
  );
}
